import moment from 'moment';

export class DateSerializer {
  private static ISO_LOCAL_DATE_TIME = 'YYYY-MM-DDTHH:mm:ss.SSS';

  static deserialize(dayStr: string): moment.Moment {
    if (dayStr) {
      return moment.utc(dayStr, this.ISO_LOCAL_DATE_TIME);
    }
    return null;
  }
}
